/**
 * Created by Tengfei Li on 2026-01-20
 */

import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import i18n from "i18next";
import { connect } from "react-redux";
import actions from "../../redux/action";
import { SelectItem } from "../../components/select-item";
import { http } from "../../common/request";
import { HttpURLS } from "../../common/http-url-define";

function EditDevices(props) {
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    props.onRefreshConfigList();
  },[]);

  const commit = () => {
    setLoading(true);
    http("put", HttpURLS.DEVICE_URL, {
      macList: props.selectedRows,
      privateConfigId: selectedConfig.value,
    })
      .then((res) => {
        const { code } = res.data;
        if (code === 200) {
          props.onRefreshPrivateDevices(props.language, { hadPrivate: true });
          props.onOk({ code, configName: selectedConfig.label });
        } else {
          props.onOk({ code });
        }
      })
      .catch((err) => {
        props.onOk({ code: err.toString() });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      width={380}
      cancelText={i18n.t("cancel")}
      okText={i18n.t("consent")}
      onCancel={props.onCancel}
      style={{ width: 600 }}
      onOk={commit}
      okButtonProps={{ disabled: !selectedConfig || loading }}
      confirmLoading={loading}
      title={i18n.t("select_config")}
      visible={props.visible}
    >
      <label>
        {i18n
          .t("selected_devices_count")
          .replace("@$", `${props.selectedRows?.length}`)}
      </label>
      <SelectItem
        options={props.configList}
        style={{ marginTop: 10 }}
        onSelect={(event) => {
          setSelectedConfig(event);
        }}
      />
    </Modal>
  );
}

const mapState2Props = (state) => {
  return {
    language: state.language.language,
    configList: state.config.configList.map(({ id, name }) => ({
      label: name,
      value: id,
    })),
  };
};

const mapDispatch2Props = (dispatch) => {
  return {
    onRefreshConfigList: () => dispatch(actions.onRefreshConfigList()),
    onRefreshPrivateDevices: (language, filter) =>
      dispatch(actions.onDeviceList(language, filter)),
  };
};

export default connect(mapState2Props, mapDispatch2Props)(EditDevices);
